import InputUtility from '@sparta.sales.utilities/input-utility/dist/es6.js';
import CommonUtility from '@sparta.sales.utilities/common-utility/dist/es6.js';

var index = {
  InputUtility,
  GeneralUtility: CommonUtility
};

export { index as default };
